export default "__VITE_ASSET__BFEcxCIm__"